import { AlertService } from '../../shared/toast/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomLoadingService } from 'src/app/shared/custom-loading/custom-loading.service';
import { SettingsService } from '../settings.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomValidators } from 'src/app/shared/Validators/custom-validators';

@Component({
  selector: 'app-profile',
  templateUrl: './mailing-address.component.html',
  styleUrls: ['./mailing-address.component.css']
})
export class MailingAddressComponent implements OnInit {
  error: any
  public title: string = "MailingAddress";
  public mailingAddressForm: FormGroup;
  constructor(
    private loadingService: CustomLoadingService,
    private settingService: SettingsService,
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private toastService: AlertService,
    private router: Router) {

    this.mailingAddressForm = this.formBuilder.group({
      "MailingAddressLine1": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "MailingAddressLine2": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "City": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "State": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "Zipcode": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator, , Validators.minLength(5)])],
      "Contact": ['', Validators.compose([Validators.required,CustomValidators.nospaceValidator])],
      "Fax": ['', Validators.compose([Validators.required,CustomValidators.nospaceValidator])]
    });
    this.getMailingAddress();
  }

  ngOnInit() {



  }
  getMailingAddress() {

    this.loadingService.show();
    this.settingService.getMailingAddress().subscribe(res => {
      this.mailingAddressForm.get("MailingAddressLine1").setValue(res.MailingAddressLine1);
      this.mailingAddressForm.get("MailingAddressLine2").setValue(res.MailingAddressLine2);
      this.mailingAddressForm.get("City").setValue(res.City);
      this.mailingAddressForm.get("State").setValue(res.State);
      this.mailingAddressForm.get("Contact").setValue(res.Contact);
      this.mailingAddressForm.get("Zipcode").setValue(res.Zipcode);
      this.mailingAddressForm.get("Fax").setValue(res.Fax);

      this.loadingService.hide();
    }, (error) => {
      this.error = this.translateService.instant("Common.Error.Exception");
      this.loadingService.hide();

    }, () => {
      this.loadingService.hide();
    })
  }


  submit(model: any, isvalid: boolean) {
    
    console.log(this.mailingAddressForm.controls);
    
    if (isvalid) {
      this.loadingService.show();
      this.settingService.updateMailingAddress(model).subscribe(res => {

        this.loadingService.hide();
        this.toastService.success(this.translateService.instant("MailingAddress.Messages.Successful"), { keepAfterRouteChange: true });
  //      this.toastService.activate(this.translateService.instant("MailingAddress.Messages.Successful"))
        this.router.navigate(["/settings"])
      }, (error) => {

        this.error = this.translateService.instant("Common.Error.Exception");
        this.loadingService.hide();

      }, () => {
        this.loadingService.hide();
      })
    }

  }

}